(function () {
  function init() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;

    var mainBtn = document.querySelector(
      '.product-info__buy-buttons buy-buttons button[type="submit"]'
    );
    if (!mainBtn) return;

    var stickyBtn = bar.querySelector('[data-sticky-atc-btn]');

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (stickyBtn.hasAttribute('disabled')) return;
        mainBtn.click();
      });

      var syncLoadingState = function () {
        var loading =
          mainBtn.hasAttribute('disabled') ||
          mainBtn.getAttribute('aria-busy') === 'true';
        stickyBtn.toggleAttribute('disabled', loading);
        stickyBtn.setAttribute('aria-busy', loading ? 'true' : 'false');
      };

      var attrObserver = new MutationObserver(syncLoadingState);
      attrObserver.observe(mainBtn, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-busy'],
      });
    }

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var rootBounds = entry.rootBounds;
          var isAboveViewport =
            !entry.isIntersecting &&
            rootBounds &&
            entry.boundingClientRect.bottom <= rootBounds.top;

          if (isAboveViewport) {
            bar.classList.add('is-visible');
            bar.setAttribute('aria-hidden', 'false');
          } else {
            bar.classList.remove('is-visible');
            bar.setAttribute('aria-hidden', 'true');
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(mainBtn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
